import s from './SaasDashboard.module.scss';

// ── 통합 관제 SaaS 미니 대시보드(홈페이지용 재현) — 2026-09-08 사용자 ──────────────────────
//   실제 대시보드(https://evstech-iot.com/?page=data '그래프 분석') 실측 재현:
//   다크 네이비 패널 + '현장 WBGT 추이' + Y축 20~38℃ + 4단계 기준선(관심31·주의33 주황 / 경고35·위험38 적, 우측 라벨)
//   + 보라→주황 그라데이션 데이터선 + 노드 마커. 요약 KPI 4카드(연결장비/경보/최고체감/평균체감)는 전체 대시보드 근거.
//   ★대시보드 소스 수정 아님. 홈페이지 표현용 네이티브 SVG(경량·배포 안전). [[evs-dashboard-saas-for-homepage]].
const KPIS = [
  { k: '연결 장비', v: '115', u: '대 온라인', c: '#00AEEF' },
  { k: '경보 발생(오늘)', v: '3', u: '건', c: '#f59e0b' },
  { k: '최고 체감온도', v: '34.2', u: '℃ 주의', c: '#e5342b' },
  { k: '평균 체감온도', v: '29.8', u: '℃', c: '#22a45f' },
];
// 좌표: Y 20~38℃ → 그래프 y. t→y: 300-(t-20)*(280/18)
const TOP = 20, BOT = 300, TMIN = 20, TMAX = 38;
const y = (t: number) => BOT - (t - TMIN) * ((BOT - TOP) / (TMAX - TMIN));
const X0 = 40, X1 = 776;
const DATA = [24.1, 24.8, 25.0, 24.9, 25.1, 25.3, 25.0, 24.6, 23.4, 22.1, 21.6, 21.5, 21.4];
const px = (i: number) => X0 + (i / (DATA.length - 1)) * (X1 - X0);
const LINE = DATA.map((t, i) => `${px(i)},${y(t).toFixed(1)}`).join(' ');
const AREA = `${X0},${BOT} ${LINE} ${X1},${BOT}`;
const TIERS = [
  { t: 31, c: '#f2a11e', label: '관심 31℃' },
  { t: 33, c: '#ef7a1f', label: '주의 33℃' },
  { t: 35, c: '#e5342b', label: '경고 35℃' },
  { t: 38, c: '#cf2a2a', label: '위험 38℃' },
];
const YTICKS = [20, 24, 28, 32, 36, 38];

export default function SaasDashboard() {
  return (
    <div className={s.dash}>
      {/* 요약 KPI 카드 */}
      <div className={s.kpis}>
        {KPIS.map((k, i) => (
          <div key={i} className={s.kpi} style={{ ['--kc' as string]: k.c } as React.CSSProperties}>
            <span className={s.kpiK}>{k.k}</span>
            <span className={s.kpiV}>{k.v}<em>{k.u}</em></span>
          </div>
        ))}
      </div>

      {/* WBGT 추이 그래프 */}
      <div className={s.chart}>
        <div className={s.chartHead}>
          <div><b>현장 WBGT 추이</b><span>한 시간에 한 점 · 평균 · 통합 관제</span></div>
          <span className={s.report}>리포트</span>
        </div>
        <svg viewBox="0 0 840 320" className={s.svg} role="img" aria-label="현장 WBGT 추이 그래프">
          <defs>
            <linearGradient id="wbgtLine" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0%" stopColor="#a06bf0" /><stop offset="100%" stopColor="#f9803a" />
            </linearGradient>
            <linearGradient id="wbgtArea" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#a06bf0" stopOpacity=".22" /><stop offset="100%" stopColor="#a06bf0" stopOpacity="0" />
            </linearGradient>
          </defs>
          {/* Y 격자 + 눈금 */}
          {YTICKS.map((t) => (
            <g key={t}>
              <line x1={X0} x2={X1} y1={y(t)} y2={y(t)} stroke="rgba(255,255,255,.07)" strokeWidth="1" />
              <text x={X0 - 8} y={y(t) + 4} className={s.ytick} textAnchor="end">{t}℃</text>
            </g>
          ))}
          {/* 4단계 기준선(점선) + 우측 라벨 */}
          {TIERS.map((tr, i) => (
            <g key={i}>
              <line x1={X0} x2={X1} y1={y(tr.t)} y2={y(tr.t)} stroke={tr.c} strokeWidth="1.6" strokeDasharray="6 5" opacity=".85" />
              <text x={X1 + 8} y={y(tr.t) + 4} className={s.tierLabel} fill={tr.c}>{tr.label}</text>
            </g>
          ))}
          {/* 데이터 */}
          <polyline points={AREA} fill="url(#wbgtArea)" stroke="none" />
          <polyline points={LINE} fill="none" stroke="url(#wbgtLine)" strokeWidth="3" strokeLinejoin="round" strokeLinecap="round" />
          {DATA.map((t, i) => <circle key={i} cx={px(i)} cy={y(t)} r="4" fill="#141f2c" stroke="#c07be0" strokeWidth="2" />)}
        </svg>
      </div>
    </div>
  );
}
